var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_24dp_5F6368_FILL1_wght400_GRAD0_opsz24 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 18.8182L12 5L20 18.8182H4ZM12 16.6364C12.2061 16.6364 12.3788 16.5667 12.5182 16.4273C12.6576 16.2879 12.7273 16.1151 12.7273 15.9091C12.7273 15.703 12.6576 15.5303 12.5182 15.3909C12.3788 15.2515 12.2061 15.1818 12 15.1818C11.7939 15.1818 11.6212 15.2515 11.4818 15.3909C11.3424 15.5303 11.2727 15.703 11.2727 15.9091C11.2727 16.1151 11.3424 16.2879 11.4818 16.4273C11.6212 16.5667 11.7939 16.6364 12 16.6364ZM11.2727 14.4545H12.7273V10.8182H11.2727V14.4545Z",
    fill: "#FF2121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarning);
export default __webpack_public_path__ + "static/media/error-warning.cd3ab8fd212a82a4d535329dc4f7054e.svg";
export { ForwardRef as ReactComponent };